import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/**
 * Silence noisy errors injected by browser wallet extensions (e.g. MetaMask's
 * `inpage.js`). They are not part of this site — the extension auto-injects
 * into every page and its failed `connect` calls bubble up to window, which
 * triggers CRA's dev error overlay.
 */
function isExtensionNoise(message, source) {
  const text = `${message || ""} ${source || ""}`.toLowerCase();
  return (
    text.includes("metamask") ||
    text.includes("inpage.js") ||
    text.includes("chrome-extension://") ||
    text.includes("moz-extension://")
  );
}

window.addEventListener(
  "error",
  (event) => {
    if (isExtensionNoise(event?.message, event?.filename)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event?.reason;
    const message = typeof reason === "string" ? reason : reason?.message;
    const stack = reason?.stack || "";
    if (isExtensionNoise(message, stack)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
